import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface Props {
  className?: string;
}

const Outlink = (props: Props) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="-4 0 24 16">
      <g transform="matrix(1 0 0 1 -1770 -3316 )">
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M 14.2222222222222 8  L 14.2222222222222 14  L 2 14  L 2 1.77777777777778  L 8 1.77777777777778  L 8 0  L 1.77777777777778 0  C 0.795555555555556 0  0 0.795555555555556  0 1.77777777777778  L 0 14.2222222222222  C 0 15.2044444444444  0.795555555555556 16  1.77777777777778 16  L 14.2222222222222 16  C 15.2044444444444 16  16 15.2044444444444  16 14.2222222222222  L 16 8  L 14.2222222222222 8  Z M 16 0  L 9.77777777777778 0  L 9.77777777777778 1.77777777777778  L 12.9644444444444 1.77777777777778  L 4.22666666666667 10.5155555555556  L 5.48444444444444 11.7733333333333  L 14.2222222222222 3.03555555555556  L 14.2222222222222 6.22222222222222  L 16 6.22222222222222  L 16 0  Z "
          fillRule="nonzero"
          fill="currentColor"
          stroke="none"
          transform="matrix(1 0 0 1 1770 3316 )"
        />
      </g>
    </SvgIcon>
  );
};

export default Outlink;
